import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAustralianAlcoholTariff implements BaseEnumType {
  private static allValues: EnumAustralianAlcoholTariff[] = []; // make sure this is top-most
  
  public static none = new EnumAustralianAlcoholTariff(0, "None", "enum_australian_alcohol_tariff_none");
  public static beerAbvUpto3Less8LOrUpto48LNoPump_1_1 = new EnumAustralianAlcoholTariff(101, "BeerAbvUpto3Less8LOrUpto48LNoPump_1_1", "enum_australian_alcohol_tariff_beer_abv_upto3_less8_l_or_upto48_l_no_pump_1_1");
  public static beerAbvUpto3Over48LOr8LPlusPump_1_2 = new EnumAustralianAlcoholTariff(102, "BeerAbvUpto3Over48LOr8LPlusPump_1_2", "enum_australian_alcohol_tariff_beer_abv_upto3_over48_l_or8_l_plus_pump_1_2");
  public static beerAbv3To3_5Less8LOrUpto48LNoPump_1_5 = new EnumAustralianAlcoholTariff(105, "BeerAbv3To3_5Less8LOrUpto48LNoPump_1_5", "enum_australian_alcohol_tariff_beer_abv3_to3_5_less8_l_or_upto48_l_no_pump_1_5");
  public static beerAbv3To3_5Over48LOr8LPlusPump_1_6 = new EnumAustralianAlcoholTariff(106, "BeerAbv3To3_5Over48LOr8LPlusPump_1_6", "enum_australian_alcohol_tariff_beer_abv3_to3_5_over48_l_or8_l_plus_pump_1_6");
  public static beerAbvOver3_5Less8LOrUpto48LNoPump_1_10 = new EnumAustralianAlcoholTariff(110, "BeerAbvOver3_5Less8LOrUpto48LNoPump_1_10", "enum_australian_alcohol_tariff_beer_abv_over3_5_less8_l_or_upto48_l_no_pump_1_10");
  public static beerAbvOver3_5Over48LOr8LPlusPump_1_11 = new EnumAustralianAlcoholTariff(111, "BeerAbvOver3_5Over48LOr8LPlusPump_1_11", "enum_australian_alcohol_tariff_beer_abv_over3_5_over48_l_or8_l_plus_pump_1_11");
  public static beerAbvUpto3NonCommercial_1_15 = new EnumAustralianAlcoholTariff(115, "BeerAbvUpto3NonCommercial_1_15", "enum_australian_alcohol_tariff_beer_abv_upto3_non_commercial_1_15");
  public static beerAbvOver3NonCommercial_1_16 = new EnumAustralianAlcoholTariff(116, "BeerAbvOver3NonCommercial_1_16", "enum_australian_alcohol_tariff_beer_abv_over3_non_commercial_1_16");
  public static otherAbvUpto10_2 = new EnumAustralianAlcoholTariff(200, "OtherAbvUpto10_2", "enum_australian_alcohol_tariff_other_abv_upto10_2");
  public static brandy_3_1 = new EnumAustralianAlcoholTariff(301, "Brandy_3_1", "enum_australian_alcohol_tariff_brandy_3_1");
  public static otherAbvOver10_3_2 = new EnumAustralianAlcoholTariff(302, "OtherAbvOver10_3_2", "enum_australian_alcohol_tariff_other_abv_over10_3_2");
  public static spiritsExemptForFortifyingWine_3_5 = new EnumAustralianAlcoholTariff(305, "SpiritsExemptForFortifyingWine_3_5", "enum_australian_alcohol_tariff_spirits_exempt_for_fortifying_wine_3_5");
  public static spiritsSoldForExemptUsage_3_6 = new EnumAustralianAlcoholTariff(306, "SpiritsSoldForExemptUsage_3_6", "enum_australian_alcohol_tariff_spirits_sold_for_exempt_usage_3_6");
  public static spiritsForExemptUsage_3_7 = new EnumAustralianAlcoholTariff(307, "SpiritsForExemptUsage_3_7", "enum_australian_alcohol_tariff_spirits_for_exempt_usage_3_7");
  public static spiritsDenatured_3_8 = new EnumAustralianAlcoholTariff(308, "SpiritsDenatured_3_8", "enum_australian_alcohol_tariff_spirits_denatured_3_8");
  public static otherSpirits_3_10 = new EnumAustralianAlcoholTariff(310, "OtherSpirits_3_10", "enum_australian_alcohol_tariff_other_spirits_3_10");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAustralianAlcoholTariff.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumAustralianAlcoholTariff.none; }
  public isBeerAbvUpto3Less8LOrUpto48LNoPump_1_1() { return this === EnumAustralianAlcoholTariff.beerAbvUpto3Less8LOrUpto48LNoPump_1_1; }
  public isBeerAbvUpto3Over48LOr8LPlusPump_1_2() { return this === EnumAustralianAlcoholTariff.beerAbvUpto3Over48LOr8LPlusPump_1_2; }
  public isBeerAbv3To3_5Less8LOrUpto48LNoPump_1_5() { return this === EnumAustralianAlcoholTariff.beerAbv3To3_5Less8LOrUpto48LNoPump_1_5; }
  public isBeerAbv3To3_5Over48LOr8LPlusPump_1_6() { return this === EnumAustralianAlcoholTariff.beerAbv3To3_5Over48LOr8LPlusPump_1_6; }
  public isBeerAbvOver3_5Less8LOrUpto48LNoPump_1_10() { return this === EnumAustralianAlcoholTariff.beerAbvOver3_5Less8LOrUpto48LNoPump_1_10; }
  public isBeerAbvOver3_5Over48LOr8LPlusPump_1_11() { return this === EnumAustralianAlcoholTariff.beerAbvOver3_5Over48LOr8LPlusPump_1_11; }
  public isBeerAbvUpto3NonCommercial_1_15() { return this === EnumAustralianAlcoholTariff.beerAbvUpto3NonCommercial_1_15; }
  public isBeerAbvOver3NonCommercial_1_16() { return this === EnumAustralianAlcoholTariff.beerAbvOver3NonCommercial_1_16; }
  public isOtherAbvUpto10_2() { return this === EnumAustralianAlcoholTariff.otherAbvUpto10_2; }
  public isBrandy_3_1() { return this === EnumAustralianAlcoholTariff.brandy_3_1; }
  public isOtherAbvOver10_3_2() { return this === EnumAustralianAlcoholTariff.otherAbvOver10_3_2; }
  public isSpiritsExemptForFortifyingWine_3_5() { return this === EnumAustralianAlcoholTariff.spiritsExemptForFortifyingWine_3_5; }
  public isSpiritsSoldForExemptUsage_3_6() { return this === EnumAustralianAlcoholTariff.spiritsSoldForExemptUsage_3_6; }
  public isSpiritsForExemptUsage_3_7() { return this === EnumAustralianAlcoholTariff.spiritsForExemptUsage_3_7; }
  public isSpiritsDenatured_3_8() { return this === EnumAustralianAlcoholTariff.spiritsDenatured_3_8; }
  public isOtherSpirits_3_10() { return this === EnumAustralianAlcoholTariff.otherSpirits_3_10; }

  public static getValues(): readonly EnumAustralianAlcoholTariff[] {
    return EnumAustralianAlcoholTariff.allValues;
  }

  public static getValuesExcept0(): readonly EnumAustralianAlcoholTariff[] {
    return EnumAustralianAlcoholTariff.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAustralianAlcoholTariff {
    const found = EnumAustralianAlcoholTariff.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAustralianAlcoholTariff - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAustralianAlcoholTariff): EnumAustralianAlcoholTariff {
    const found = name ? EnumAustralianAlcoholTariff.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAustralianAlcoholTariff - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAustralianAlcoholTariff>): boolean {
    return this.key === other?.key;
  }
}